import styled from 'styled-components';
export const StyledSearchWrapper = styled.div.withConfig({
  displayName: "StyledSearchWrapper",
  componentId: "sc-11hqz49-0"
})(["box-shadow:rgba(0,0,0,0) 0px 0px 0px 0px;", ""], ({
  isOpen
}) => isOpen && `
      box-shadow: 0 0 30px 13px rgb(0 0 0 / 20%);
      display: block !important;
      border-radius: 10px;
      background: #FBFBFB; /* TODO: remove this once we have the new background color */
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1311;
      overflow: hidden !important;
      transition: none !important;
`);